import { Card, CardContent, Grid } from '@material-ui/core';
import React from 'react';
import {useStyles} from './style';

export default function Formulario({children}) {
    const classes = useStyles();

    return (
        <Card>
            <CardContent >
                <Grid  container justify="center" alignItems="center" spacing={1} >
                    {children}
                </Grid>
            </CardContent>
            <div className={classes.lineaDegradadaBottom}></div>
        </Card>
    );
}